import React, { useState, useEffect } from "react";
import { projectService } from "../../services/api";
import { Container, Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../styles/ProjectList.css";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProjectAdminList = () => {
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(1);
  const [maxProjects, setMaxProjects] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  // Chargement des projets validés (status === 'approved')
  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("status", "pending");
        if (searchTerm) params.append("q", searchTerm);
        const response = await projectService.getAllProjects(params);
        console.log("Response data:", response.data);
        setProjects(response.data.results);
        setMaxProjects(response.data.count);
        setError(null);
      } catch (err) {
        setError("Impossible de charger les projets.");
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [page, searchTerm]);

  return (
    <div>
      <div className="">
        <h1 className="mb-4">projets du Patrimoine Linguistique Algérien</h1>
        {/* Ajoute ici le reste de l'UI pour afficher entries */}

        <div className="dict-searchbar">
          <input
            type="text"
            placeholder="Rechercher un projet"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
          />
          <span className="dict-search-ico">
            <FontAwesomeIcon icon={faSearch} />
          </span>
        </div>
      </div>

      {/* Main content */}
      <main className="projects-section">
        {loading && <Spinner animation="border" />}
        {error && <Alert variant="danger">{error}</Alert>}
        {!loading && projects.length === 0 && <div>Aucun projet trouvé.</div>}

        {projects.map((project) => (
          <div
            className="project-card"
            key={project.id}
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/projects/${project.id}`)}
          >
            
            <div className="project-details">
              <h3>
                <strong>Titre du projet :</strong> {project.title}
              </h3>
              <p className="description">{project.description}</p>
              <p>
                <strong>Auteur :</strong> {project.author}
              </p>
              <p>
                <strong>Année :</strong> {project.year}
              </p>
              <div className="code-section">
                <span>
                  <strong>Code :</strong>
                </span>
                {project.content?.link ? (
                  <a
                    href={project.content.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {/* <img
                    src={githubIcon}
                    alt="GitHub"
                    className="github-icon"
                  /> */}
                  </a>
                ) : (
                  <span style={{ marginLeft: 8, color: "#aaa" }}>
                    Non disponible
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}

        {/* Pagination : Afficher Plus */}
        {maxProjects > page * 10 && (
          <div className="load-more-container">
            <button className="load-more-btn" onClick={() => setPage(page + 1)}>
              Afficher Plus
            </button>
          </div>
        )}
      </main>
    </div>
  );
};

export default ProjectAdminList;
